import { Grid, TableCell, TableRow } from "@mui/material";

export const TransferTableHeaderRow = ({name, bgcolor, requiredSubject}) => {
  return (
    <TableRow>
      <TransferTableHeaderCell
        text={name}
        sx={{width: 200, fontWeight: 'bold', bgcolor}}
      />
      <TransferTableHeaderCell
        align='center'
        sx={{bgcolor, width: 100}}
        text={requiredSubject ? "借方勘定科目" : null}
      />
      <TransferTableHeaderCell
        align='center'
        sx={{bgcolor, width: 100}}
        text='借方'
      />
      <TransferTableHeaderCell 
        align='center'
        sx={{bgcolor, width: 100}}
        text={requiredSubject ? "貸方勘定科目" : null}
      />
      <TransferTableHeaderCell
        align='center'
        sx={{bgcolor, width: 100}}
        text='貸方'
      />
    </TableRow>

  )
}

export const TransferTableAmountRow = ({index, name, debitSubject, debitAmount, creditSubject, creditAmount, nameBgcolor, subjectBgcolor}) => {
  return (
    <TableRow>
      <TransferTableNameCell index={index} name={name} sx={{bgcolor: nameBgcolor}}/>
      <TransferTableSubjectCell subject={debitSubject} sx={{bgcolor: subjectBgcolor}} />
      <TransferTableAmountCell amount={debitAmount} />
      <TransferTableSubjectCell subject={creditSubject} sx={{bgcolor: subjectBgcolor}} />
      <TransferTableAmountCell amount={creditAmount} />
    </TableRow>
  );
}

export const TransferTableTotalRow = ({debitAmount, creditAmount, nameBgcolor, amountBgcolor}) => {
  return (
    <TableRow>
      <TransferTableNameCell name="合計" sx={{bgcolor: nameBgcolor}}/>
      <TransferTableSubjectCell sx={{bgcolor: amountBgcolor}} />
      <TransferTableAmountCell amount={debitAmount} sx={{bgcolor: amountBgcolor}} />
      <TransferTableSubjectCell sx={{bgcolor: amountBgcolor}} />
      <TransferTableAmountCell amount={creditAmount} sx={{bgcolor: amountBgcolor}} />
    </TableRow>

  )
}

const TransferTableHeaderCell = ({text, align, sx}) => (
  <TableCell align={align || 'left'} sx={{padding: 1, fontSize: 15, ...sx}}>
    {text}
  </TableCell>
);

const TransferTableNameCell = ({index, name, sx}) => (
  <TableCell sx={{padding: 1, width: 200, ...sx}}>
    <Grid container>
      <Grid item width={20} sx={{fontSize: 15}}>
        {index}
      </Grid>
      <Grid item xs sx={{fontSize: 15}}>
        {name}
      </Grid>
    </Grid>
  </TableCell>
);

const TransferTableSubjectCell = ({subject, sx}) => (
  <TableCell sx={{padding: 1, fontSize: 15, width: 100, ...sx}}>
    {subject}
  </TableCell>
);

const TransferTableAmountCell = ({amount, sx}) => (
  <TableCell align={amount != null ? "right" : "center"} sx={{padding: 1, width: 100, fontSize: 15, ...sx}}>
    {amount != null ? amount.toLocaleString() : "-"}
  </TableCell>
);
